/**
 * Gullye — open the House List popup once, after the cart drawer is
 * dismissed on a PDP.
 *
 * This used to open Klaviyo form YqFLWx. That form is in Draft and the theme
 * hides every Klaviyo onsite form with CSS, so the add-to-cart moment showed
 * nothing at all. It now calls window.gyHouseListAuto('atc') from
 * snippets/gy-house-list.liquid, which applies the House List's own gates
 * (joined, dismissed in the last 14 days, already auto-opened this session,
 * Klaviyo-arrival, identified) and reports popup_view with trigger 'atc'.
 *
 * Only fires when ALL of these hold:
 *   · we are on a product page
 *   · an add-to-cart happened on THIS pageview
 *   · the drawer went from open to closed (X, overlay, ESC, continue shopping)
 *   · the shopper has not already submitted / is not already identified
 *   · we have not already shown it this session
 *
 * Two deliberate departures from the handover draft:
 *
 * 1. Add-to-cart is read from the theme's own cartUpdate pub/sub rather than by
 *    monkey-patching window.fetch. The draft wrapped global fetch for the life
 *    of the page, which would sit in front of every request the site makes
 *    (Klaviyo, analytics, section renders) to learn one boolean. The theme
 *    already publishes the fact, with a source, and gy-analytics.js reads it
 *    the same way.
 *
 * 2. The drawer signal is the `active` class on <cart-drawer>, confirmed from
 *    assets/cart-drawer.js (open() adds 'animate active', close() removes
 *    'active'). The draft guessed at 'is-open' / aria-hidden, which this theme
 *    does not use.
 */
(function () {
  'use strict';

  var SESSION_KEY = 'gy_atc_popup_shown'; // once per session
  var SUBMITTED_KEY = 'gy_kl_submitted'; // persists across sessions

  // Adds only. Cart-page quantity edits and the gift-wrap toggle publish
  // nothing here, so neither can stand in for an add-to-cart.
  var ADD_SOURCES = { 'product-form': 1, 'quick-add': 1, 'quick-add-bulk': 1 };

  var addedThisPageview = false;
  var drawerWasOpen = false;
  var leavingPage = false;

  // --- never re-show to someone who has already given us their details ------
  window.addEventListener('klaviyoForms', function (e) {
    if (e && e.detail && e.detail.type === 'submit') {
      try { localStorage.setItem(SUBMITTED_KEY, '1'); } catch (err) {}
    }
  });

  function alreadySubmitted() {
    try { if (localStorage.getItem(SUBMITTED_KEY) === '1') return true; } catch (err) {}
    // Klaviyo writes __kla_id; if it carries an email the visitor is known.
    try {
      var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if (m) {
        var d = JSON.parse(atob(decodeURIComponent(m[1])));
        if (d && d.$email) return true;
      }
    } catch (err) {}
    return false;
  }

  function isPDP() {
    var t = document.body && document.body.getAttribute('data-gy-page-type');
    if (t) return t === 'product';
    return /\/products\//.test(window.location.pathname);
  }

  function shownThisSession() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (err) { return false; }
  }

  function log() {
    if (!window.GY_DEBUG) return;
    console.log.apply(console, ['[gy-atc-popup]'].concat([].slice.call(arguments)));
  }

  function openPopup() {
    if (leavingPage) { log('skip: navigating away'); return; }
    if (!isPDP()) { log('skip: not a PDP'); return; }
    if (!addedThisPageview) { log('skip: no add-to-cart this pageview'); return; }
    if (alreadySubmitted()) { log('skip: already submitted or identified'); return; }
    if (shownThisSession()) { log('skip: already shown this session'); return; }
    log('opening House List');
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (err) {}
    if (typeof window.gyHouseListAuto === 'function') window.gyHouseListAuto('atc');
    else log('skip: gyHouseListAuto missing');
  }

  // --- 1. add-to-cart, via the theme's pub/sub ------------------------------
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && ADD_SOURCES[event.source]) { addedThisPageview = true; log('add-to-cart seen, source:', event.source); }
      });
    }
  } catch (err) {
    if (window.GY_DEBUG) console.warn('[gy-atc-popup] cartUpdate subscribe failed', err);
  }

  // --- 2. drawer open -> closed --------------------------------------------
  // Tracked as a transition, not a state: the class attribute mutates several
  // times per open (open() adds 'animate' then 'active'), and a bare "not
  // active" test would fire on every one of those.
  var drawer = document.querySelector('cart-drawer');
  log(drawer ? 'watching cart-drawer' : 'NO cart-drawer found');
  if (drawer) {
    new MutationObserver(function () {
      var open = drawer.classList.contains('active');
      if (open) { if (!drawerWasOpen) log('drawer opened'); drawerWasOpen = true; return; }
      if (!drawerWasOpen) return;
      drawerWasOpen = false;
      log('drawer closed; scheduling check');
      window.setTimeout(openPopup, 400); // let the close animation finish
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  // Checkout and View cart leave the page rather than dismissing the drawer.
  window.addEventListener('pagehide', function () { leavingPage = true; });
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href], button[name="checkout"]');
    if (!a) return;
    var href = a.getAttribute && a.getAttribute('href');
    if ((href && /\/(cart|checkout)/.test(href)) || a.name === 'checkout') leavingPage = true;
  }, true);
})();
